/* Vanilla JS reveal utility; respects reduced motion and Shopify editor hot re-render. */
(() => {
  'use strict';
  const query = '.veloura-reveal';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const allVisible = (root = document) => root.querySelectorAll(query).forEach(node => node.classList.add('is-visible'));
  const init = (root = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) {
      allVisible(root);
      return;
    }
    if (!observer) observer = new IntersectionObserver((entries, instance) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll(query).forEach(node => {
      if (!node.classList.contains('is-visible')) observer.observe(node);
    });
  };
  const ready = () => { document.documentElement.classList.add('veloura-js'); init(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once:true });
  else ready();
  document.addEventListener('shopify:section:load', e => init(e.target));
  reduced.addEventListener?.('change', () => { if (reduced.matches) { observer?.disconnect(); allVisible(); } else init(); });
})();